import { sortByOrder } from 'utils/collection-manipulation/array-sort-by';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { AToZData } from 'interfaces/generic';
import { GLOBALS } from './global-variables';
import store from 'store';
import { setMenuJsonData } from 'store/actions/app-data';

export const fetchMenuData = (setLoading?: (arg: boolean) => void): void => {
  if (SpringConfigs.A_TO_Z_MENU_DATA_PATH) {
    fetch(SpringConfigs.A_TO_Z_MENU_DATA_PATH)
      .then(responce => responce.json())
      .then(resp => {
        let data: AToZData[] = Object.values(resp);

        data = sortByOrder(Object.values(data));

        if (!GLOBALS.appConfigs.springPagesUrls) {
          for (const elem of data) {
            elem.categoryBottom = elem.category;

            if (elem.type === 'live-casino') {
              elem.category = undefined;
            }

            if (elem.path === '/') {
              Object.assign(SpringConfigs.PAGE_URLS, {
                homepageKey: elem.type
              });
            }
          }
        }

        if (SpringConfigs.USER_PERSONALIZATION_ENABLED) {
          data.forEach(item => {
            if (item.icon === 'casino.colored.favorite') {
              item.icon = 'casino.colored.personalization';
            }
          });
        }

        store.dispatch(setMenuJsonData(data));
        setLoading && setLoading(false);
      })
      .catch(console.error);
  } else {
    setLoading && setLoading(false);
  }
};
